<template>
    <v-container  :dark="$store.getters.getColorPalette().isDark"  fluid>
        <InfoAlert :showDismissibleAlert="showDismissibleAlert" v-on:close="showDismissibleAlert=false" :info="info" />
        <!-- <v-row > 
            <v-col>
                <span v-if="edit" :dark="$store.getters.getColorPalette().isDark" :class="'text-subtitle-1'+$store.getters.getColorPalette().accentName+'--text'">Edit Bullet Gauge Widget</span>
                <span v-else :dark="$store.getters.getColorPalette().isDark" :class="'text-subtitle-1'+$store.getters.getColorPalette().accentName+'--text'">Add Bullet Gauge Widget</span>
            </v-col>
        </v-row> -->
        <v-form  :dark="$store.getters.getColorPalette().isDark"  ref="widgetForm" v-model="valid">
        <v-card  :dark="$store.getters.getColorPalette().isDark" :style="{'border': '1px solid '+ $store.getters.getColorPalette().panelBorderColorCode, 'background-color':$store.getters.getColorPalette().background2ColorCode}" flat outlined class="px-2 mb-2">    
            <v-card-title v-if="edit" class="sub-heading">{{$store.getters.getTextMap().edit_bullet_gauge_widget}}</v-card-title>
            <v-card-title v-else class="sub-heading">{{$store.getters.getTextMap().add_bullet_gauge_widget}}</v-card-title>
            <v-row>
                <v-col align-self="center">
                    <v-skeleton-loader v-if="loading" class="mx-auto" type="text"></v-skeleton-loader>
                    <v-text-field dense outlined v-if="!loading" v-model="widgetForm.label" :counter="30" :rules="[rules.required]" label="Widget Label" required></v-text-field>
                </v-col>
                <v-col align-self="center">
                    <v-select
                        :dark="$store.getters.getColorPalette().isDark" 
                       :color="$store.getters.getColorPalette().inputtextColor"
                        :menu-props="{dark: $store.getters.getColorPalette().isDark}"
                        v-if="!loading"
                        v-model="widgetForm.width"
                        :items="widthOptions"
                        :label="$store.getters.getTextMap().widget_width"
                        dense
                        outlined
                        item-text="label"
                        item-value="value"
                        ></v-select>  
                </v-col>
                <v-col align-self="center">
                    <v-select
                       :dark="$store.getters.getColorPalette().isDark" 
                      :color="$store.getters.getColorPalette().inputtextColor"
                   :menu-props="{dark: $store.getters.getColorPalette().isDark}"
                        v-if="!loading"
                        v-model="widgetForm.height"
                        :items="heightOptions"
                        :label="$store.getters.getTextMap().widget_height"
                        dense
                        outlined
                        item-text="label"
                        item-value="value"
                        ></v-select>  
                </v-col>
                <v-col align-self="center" >
                    <v-select
                            v-if="!loading"
                            v-model="widgetForm.background_color"
                            :items="$store.getters.getBackgroundColorOptions()"
                            :label="$store.getters.getTextMap().background_color"
                            dense
                            outlined
                            item-text="label"
                            item-value="value"
                            clearable
                          :menu-props="{dark: $store.getters.getColorPalette().isDark}"
                        >
                        <template v-slot:selection="{ item }">
                    <div :style="{'background-color':item.value}">{{ item.label }}</div>
                  </template>
                  <template v-slot:item="{ item }">
                  <div :style="{'background-color':item.value}">{{ item.label }}</div>
                  </template>
                </v-select>
                </v-col>
                <v-col v-if="!disableTimeframe" align-self="center">
                    <v-select
                    :dark="$store.getters.getColorPalette().isDark" 
                        :color="$store.getters.getColorPalette().inputtextColor"
                       :menu-props="{dark: $store.getters.getColorPalette().isDark}"
                        v-if="!loading"
                        v-model="timeFrame"
                        :items="tdOptions"
                        :label="$store.getters.getTextMap().timeFrame"
                        dense
                        outlined
                        item-text="label"
                        item-value="value"
                        ></v-select>  
                </v-col>
                <v-col v-if="edit" align-self="center">
                    <v-skeleton-loader v-if="loading" class="mx-auto" type="text"></v-skeleton-loader>
                    <v-text-field
                            v-if="!loading"
                            v-model="widgetForm.seq"
                            :counter="3"
                            :label="$store.getters.getTextMap().sequence"
                            dense
                            outlined
                            ></v-text-field>
                </v-col>
            </v-row>
            <!-- <v-row>
            </v-row> -->
        
        </v-card>

        <v-card  flat outlined  :dark="$store.getters.getColorPalette().isDark"  :style="{'border': '1px solid '+ $store.getters.getColorPalette().panelBorderColorCode, 'background-color':$store.getters.getColorPalette().background2ColorCode}" >
            <!-- <v-row style="margin-top:10px;padding-bottom:10px;padding-left:10px;">
                <v-col style="margin-bottom: 20px;">
                    <v-btn dark style="margin-right:20px;" color="blue" small filled @click="addSingleParam">Add Params</v-btn>
                </v-col>
            </v-row> -->
            <!-- Single Param -->
            <!-- <v-card  :dark="$store.getters.getColorPalette().isDark" :color="$store.getters.getColorPalette().background1ColorCode" flat outlined style="margin-top:20px;"> -->
                <!-- <h2 style="color:#80CBC4; margin-top:10px; padding-left:10px;">ADD PARAMS TO GRAPH</h2> -->
                
                    <v-container>
                        <v-row>
                            <!-- <v-col>
                                <v-skeleton-loader  v-if="loading" class="mx-auto" type="text"></v-skeleton-loader>
                                    <v-text-field
                                        v-if="!loading"
                                        v-model="form.label"
                                        :counter="30"
                                        :rules="[rules.required]"
                                        label="Label"
                                        required
                                    ></v-text-field>
                            </v-col>     -->
                                <v-col>
                                <v-skeleton-loader v-if="loading" class="mx-auto" type="text"></v-skeleton-loader>
                                <v-select
                               :dark="$store.getters.getColorPalette().isDark" 
                      :color="$store.getters.getColorPalette().inputtextColor"
                        :menu-props="{dark: $store.getters.getColorPalette().isDark}"
                                    v-if="!loading"
                                    v-model="workspace"
                                    :items="workspaceOptions"
                                    :label="$store.getters.getTextMap().workspace"
                                    outlined
                                    dense          
                                    item-text="label"
                                    item-value="value"
                                    
                                    
                                ></v-select>
                            </v-col>
                            <v-col>
                                <v-skeleton-loader  v-if="loading" class="mx-auto" type="text"></v-skeleton-loader>
                                <v-select
                                  :dark="$store.getters.getColorPalette().isDark" 
                                  :color="$store.getters.getColorPalette().inputtextColor"
                                   :menu-props="{dark: $store.getters.getColorPalette().isDark}"
                                    v-if="!loading"
                                    v-model="form.machine"
                                    :items="machineOptions"
                                    :label="$store.getters.getTextMap().machine"
                                    outlined
                                    required
                                    :rules="[rules.required]"
                                    dense
                                    
                                    item-text="label"
                                    item-value="value"
                                    ></v-select>
                            </v-col>
                            
                            <!-- <v-col>
                                <v-skeleton-loader v-if="loading" class="mx-auto" type="text"></v-skeleton-loader>
                                <v-select
                                dark
                        color="cyan lighten-1"
                        :menu-props="{dark: true}"
                                    v-if="!loading"
                                    v-model="form.params"
                                    :items="paramOptions"
                                    label="Param"
                                    outlined
                                    item-text="label"
                                    item-value="value"
                                    multiple
                                    required
                                    :rules="[rules.required,rules.nonZeroLength]"
                                ></v-select>
                            </v-col> -->
                            <!-- <v-col>
                                <v-skeleton-loader  v-if="loading" class="mx-auto" type="text"></v-skeleton-loader>
                                    <v-text-field
                                        v-if="!loading"
                                        v-model="form.reference"
                                        :rules="[rules.required]"
                                        label="Reference Value"
                                        required
                                    ></v-text-field>
                            </v-col>  -->
                            <!-- <v-col>
                                <v-skeleton-loader v-if="loading" class="mx-auto" type="text"></v-skeleton-loader>
                                <v-select
                                    dark
                                    color="cyan lighten-1"
                                    :menu-props="{dark: true}"
                                    v-if="!loading"
                                    v-model="form.gaugeType"
                                    :items="gaugeOption"
                                    label="Gauge Type"
                                    outlined
                                    item-text="label"
                                    item-value="value"
                                    required
                                    :rules="[rules.required]"
                                ></v-select>
                            </v-col>   
                            <v-col>
                                <v-skeleton-loader v-if="loading" class="mx-auto" type="text"></v-skeleton-loader>
                                <v-select
                                    dark
                                    color="cyan lighten-1"
                                    :menu-props="{dark: true}"
                                    v-if="!loading"
                                    v-model="form.indicatorColor"
                                    :items="indicatorColorOption"
                                    label="Indicator Color"
                                    outlined
                                    item-text="label"
                                    item-value="value"
                                    required
                                    :rules="[rules.required]"
                                ></v-select>
                            </v-col>    -->
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-select
                                   :dark="$store.getters.getColorPalette().isDark" 
                                    color="cyan lighten-1"
                                    :menu-props="{dark: $store.getters.getColorPalette().isDark}"
                                    v-if="!loading"
                                    v-model="tags"
                                    :items="tagTypes"
                                    :label="$store.getters.getTextMap().tag_types"
                                    outlined
                                    item-text="label"
                                    item-value="value"
                                    required
                                    dense
                                    multiple
                                    :rules="[rules.required]"
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row v-for="tag in tags" :key="tag">
                            <v-col>
                                <v-skeleton-loader  v-if="loading" class="mx-auto" type="text"></v-skeleton-loader>
                                    <v-text-field
                                        v-if="!loading"
                                        v-model="form[tag].gauge_label"
                                        :counter="30"
                                        :rules="[rules.required]"
                                        :label="$store.getters.getTextMap().label"
                                        required
                                        dense
                                        outlined
                                    ></v-text-field>
                            </v-col>   
                                    <v-col >
                                    <v-text-field
                                        v-if="!loading"
                                        v-model="form[tag].reference"
                                        :rules="[rules.required]"
                                        :label="$store.getters.getTextMap().reference_value_for+ tag"
                                        required
                                        dense
                                        outlined
                                    ></v-text-field>
                                    </v-col>
                                    <v-col>
                                    <v-select
                                        :dark="$store.getters.getColorPalette().isDark" 
                                      :color="$store.getters.getColorPalette().inputtextColor"
                                        :menu-props="{dark: $store.getters.getColorPalette().isDark}"
                                        v-if="!loading"
                                        v-model="form[tag].gauge_type"
                                        :items="gaugeOption"
                                        :label="$store.getters.getTextMap().gauge_type"
                                        outlined
                                        item-text="label"
                                        item-value="value"
                                        required
                                        dense
                                        :rules="[rules.required]"
                                    ></v-select>
                                </v-col>
                                    <v-col>
                                    <v-select
                                       :dark="$store.getters.getColorPalette().isDark" 
                                       :color="$store.getters.getColorPalette().inputtextColor"
                                      :menu-props="{dark: $store.getters.getColorPalette().isDark}"
                                        v-if="!loading"
                                        v-model="form[tag].indicator_color"
                                        :items="indicatorColorOption"
                                        :label="$store.getters.getTextMap().indicator_color"
                                        outlined
                                        item-text="label"
                                        item-value="value"
                                        required
                                        dense
                                        :rules="[rules.required]"
                                    ></v-select>
                                </v-col>
                        </v-row>
                </v-container>
            
        <!-- </v-card> -->
        </v-card>
    </v-form>
        <v-row no-gutters>
            <v-spacer/>
                <v-col cols="auto" class="d-flex mt-2" align="right">
                    <v-btn :dark="$store.getters.getColorPalette().isDark"  :color="$store.getters.getColorPalette().submitbtnColor" small filled @click="onSubmit">{{ $store.getters.getTextMap().submit }}</v-btn>
  <v-btn class="ml-2"  :color="$store.getters.getColorPalette().cancelbtnColor" small @click="onReset">{{ $store.getters.getTextMap().cancel }}</v-btn>
                </v-col>
            </v-row>
    </v-container>
</template>

<script>
import InfoAlert from '@/components/InfoAlert'
// import CreateMultiParam from '@/components/CreateMultiParam.vue'
import axios from 'axios'
import FormRules from '@/utillities/FormRules'
export default {
    name:'AddBulletAngularGaugeWidget',
    props:['widget','seq','disableTimeframe'],
    components:{
        InfoAlert,
    },
    mounted(){
        this.init()
    },
    data(){
        return {
            counter:0,
            count:0,
            show:false,
            dialog:false,
            dialogss:false,
            loading:false,
            valid:false,
            ValidMulti:false,
            widgetValid:false,
            showDismissibleAlert:false,
            api:'createWidgetForView',
            info:'',
            edit:false,
            selectedActive:null,
            selectedApparent:null,
            selectedPF:null,
            show_active_energy:false,
            show_apparent_energy:false,
            show_pf:false,
            tags:[],
            workspace:null,
            machine:null,
            legend:false,
            textInfo:null,
            tableData:[],
            paramTemp:null,
            operatorTemp:null,
            paramArray:[],
            operatorArray:[],
            paramNeg:[],
            paramPos:[],
            paramNegFinal:[],
            paramPosFinal:[],
            // paramSingleFinal:[],
            paramMultiFinal:[],
            equation:'',
            form:{
                'active_energy':{},
                'apparent_energy':{},
                'pf':{},
            },
            widgetForm:{},
            machineOptions:[],
            paramOptions:[],
            operators:[
                {label:'+',value:'+'},
                {label:'-',value:'-'}
                ],
            gaugeOption:[
                {label:'Angular', value:'angular'},
                {label:'Bullet', value:'bullet'},
            ],
            indicatorColorOption:[
                {label:'Red for relatively higher value', value:'rrhv'},
                {label:'Green for Relatively higher value ', value:'grhv'},
            ],
            widthOptions:[
                {label:'Full screen', value:12},
                {label:'Half screen', value:6},
                {label:'1/3 screen', value:4},
                {label:'Quarter screen', value:3},
                {label:'3/4 screen', value:9},
                {label:'Auto',value:null}
            ],
            heightOptions:[
                {label:'Fixed', value:'fixed'},
                {label:'Flex', value:'flex'},
            ],
            tdOptions:[
                {label:'MTD', value:'mtd'},
                {label:'YTD', value:'ytd'}
            ],
            tagTypes:[
                {label:'Active Energy', value:'active_energy'},
                {label:'Apparent Energy', value:'apparent_energy'},
                {label:'PF', value:'pf'}
            ],
            textInfoOptions:[
                {label:'Label & percentage', value:'label+percent'},
                {label:'Value Only', value:'value'},
                {label:'Value & Percentage', value:'value+percent'},
                {label:'Percentage only', value:'percent'},
                {label:'None',value:'none'}
            ],
            rules:FormRules.rules,
            objectRules:[
                v => !!v || 'Required',
            ],
             countRules:[

                v => !!v || 'Required',

                v => (v && v>1) || 'Number of Machine should be greater than 1'

            ],
        }
    },
    computed:{
        workspaceOptions(){
            let op=[]
            let g=this.$store.state.workspaces
            for(let i of g){
                //op.push({value:i, text: i.name })
                op.push( {value:i.workspace_id, label: i.name })
                }
            return op
        },
        
        timeFrame:{
            get: function (){
                if(this.widgetForm && this.widgetForm.meta){
                    return this.widgetForm.meta.time_frame
                }else{
                    return null
                }
            },
            set: function (newValue){
                if(this.widgetForm && this.widgetForm.meta){
                    this.widgetForm.meta.time_frame=newValue
                }else{
                    this.widgetForm.meta={time_frame:newValue}
                }
            }
        }
    },
    methods:{
        init(){
            if(this.widget && this.widget.widget_id && this.widget.view_id){
                this.edit=true
                this.widgetForm=Object.assign({},this.widget)
                this.api='updateWidget'
                // console.log(this.widgetForm,'this.widgetForm')
                if(!(this.widgetForm.meta && this.widgetForm.meta.data)){
                    this.widgetForm.meta={data:[]}
                    this.tableData=[]
                }else{
                    this.tableData=this.widgetForm.meta.data
                    this.legend=this.widgetForm.meta.legend
                    this.textInfo=this.widgetForm.meta.textinfo
                    let payload=this.tableData[0]
                    this.form.machine = payload.machine
                    for(let i of payload.indicator){
                        if(!( this.tags.includes(i['tag_type']))){
                            {this.tags.push(i.tag_type)}
                            this.form[i.tag_type]=i
                        }
                    }
                }
            }else{
            if(this.widget.view_id){
                this.api='createWidgetForView'
                this.widgetForm=Object.assign({},this.widget)
                this.widgetForm.meta={data:[]}
                this.widgetForm.seq=this.seq?this.seq:0
                this.tableData=[]
            }
        }
        },
        getMachineList(){
            let op=[]
            if(this.workspace){
                let payload={
                    workspace_id:this.workspace
                }
                // console.log(payload)
                this.loading = true;
            axios.post(this.$store.state.api + "getMachinesByWorkspace", payload,{headers: {
            Authorization: 'Bearer '+ this.$store.state.jwt
            }})
                .then(response => {
                if (response.data.status == "success") {
                    //console.log(response.data);
                    let machines=response.data.machines
                //this.loading = false;
                for(let i of machines){
                  if(i && i.name){
                    op.push({value:i.machine_id, label: i.name })
                  }else{
                    op.push({value:i.machine_id, label: i.machine_id })
                  }
                }
                } else {
                    this.info = response.data.msg;
                    this.showDismissibleAlert = true;
                }
                //this.onReset()
                this.loading = false;
                })
                .catch(error => {
                this.info = error;
                this.showDismissibleAlert = true;
                this.loading = false;
                });
            }
            this.machineOptions=op
        },
        getParams(){
            //console.log('getParams called')
            //console.log(this.machine)
            if(this.machine ){
                this.loading=true
                //console.log('getParams executed')
                axios.post(this.$store.state.api+'getParamsByMachine',{machine_id:this.machine},{headers: {
                    Authorization: 'Bearer '+ this.$store.state.jwt
                    }})
                    .then(response=>{
                        //console.log(response.data)
                        if(response.data.status=='success'){
                            this.loading=false
                            //this.$store.dispatch('refreshViews')
                            this.paramOptions=[]
                            for(let i of response.data.params){
                                this.paramOptions.push({label:i.name,value:i.param_id})
                            }
                            
                        }else{
                            this.loading=false
                            this.info=response.data.msg
                            this.showDismissibleAlert=true
                        }
                    }).catch(err=>{
                        this.loading=false
                        this.info=err
                        this.showDismissibleAlert=true
                        
                    })
            }
        },
        getParamName(param){
          let p=this.$store.getters.getParameterById(param)
          if(p){
          return this.$store.getters.getDeviceById  (p['device_id'])['name'] +"-"+p['name']
          }else{
            return "Issue with getting Param Name"
          }
        },

        onSubmit(){
            this.$refs.widgetForm.validate()
            if(this.valid){
              this.loading=true
              if(!this.tableData){
                this.tableData=[]
              }
              let indicators=[]
              for(let tag of this.tags){
                let temp=this.form[tag]
                temp['tag_type']=tag
                indicators.push(temp)
                }
            //   if(this.show_pf){
            //     indicators.push({
            //             gauge_type:this.form.gaugeTypePF,
            //             gauge_label:this.form.PFLabel,
            //             reference:this.form.pf_reference,
            //             indicator_color:this.form.indicatorColorPF,
            //             tag_type:'pf'
            //         })
            //   }
            //   if(this.show_active_energy){
            //     indicators.push({
            //             gauge_type:this.form.gaugeTypeActiveEnergy,
            //             gauge_label:this.form.activeEnergyLabel,
            //             reference:this.form.active_energy_reference,
            //             indicator_color:this.form.indicatorColorActiveEnergy,
            //             tag_type:'active_energy'
            //         })
            //   }
            //   if(this.show_apparent_energy){
            //     indicators.push({
            //             gauge_type:this.form.gaugeTypeApparentEnergy,
            //             gauge_label:this.form.apparentEnergyLabel,
            //             reference:this.form.apparent_energy_reference,
            //             indicator_color:this.form.indicatorColorApparentEnergy,
            //             tag_type:'apparent_energy'
            //         })
            //   }
              if(indicators.length>3){
                this.info="You can't configure more than 3 Tags in one widget"
                this.showDismissibleAlert=true
                return
              }
              this.tableData=[{
                machine:this.form.machine,
                indicator:indicators
                },
            ]
              this.form.params=[]
              this.loading=false
            }
            this.$refs.widgetForm.validate()
            if(this.valid){
              this.loading=true
            //evt.preventDefault()
            //this.form.id=(new Date).getTime().toString()
            this.widgetForm.meta.data=this.tableData
            this.widgetForm.meta.legend=this.legend
            this.widgetForm.meta.textinfo=this.textInfo
            axios.post(this.$store.state.api+this.api,this.widgetForm,{headers: {
      Authorization: 'Bearer '+ this.$store.state.jwt
    }})
    .then(response=>{
      if(response.data.status==='success'){
            this.loading=false
            //this.dialog=false
            this.$emit('success')
            this.$emit('close')
    }else{
      //console.log(response.data.msg)
      this.info = response.data.msg;
      //this.info = d;
            this.showDismissibleAlert = true;
      //console.log(response.data.msg)
      this.loading=false
    }})
    .catch(err=>{console.log(err)
    this.info = err;
      //this.info = d;
            this.showDismissibleAlert = true;
            this.loading=false});
                //this.$store.dispatch('addDevice', d)
            
            }
        },
        onReset(){
            this.show=false,
            this.dialog=false,
            this.dialogss=false,
            this.counter=0
            this.workspace=null
            this.machine=null
            this.form.label=null
            this.form={}
            this.$refs.widgetForm.reset()
            this.loading=false
            this.$emit('close')
        },
        removeParam(param){
            //console.log("remove param")
            //console.log(param)
            //this.stream.emit('removeParam',param)
            this.form.params=this.form.params.filter(x=>x!=param)
            //this.parameter.delete(param)
            
        },
        deleteFromTable(item){
            console.log(item)
            this.tableData=this.tableData.filter(x=>x.label!=item.label)
        },
    },
    watch:{
        workspace(){
            this.getMachineList()
        },
        machine(){
            this.getParams()
        },
        widget(){
            this.init()
        }
    }
}
</script>